import React from "react";
import styled from "styled-components";
import HeaderWithSubheader from "../HeaderWithSubheader";
import SectionHeaderWithSubHeaderDark from "../SectionHeaderWithSubHeaderDark";
import { Column } from "../layout/Flex";
import Grid from "../layout/Grid";

export interface SummaryBoxMetric {
  value: string | number;
  valueSubText?: string | string[] | JSX.Element;
  dataTestId?: string;
}

interface SummaryBoxMetricsMultiProps {
  header: string;
  metricsArr: SummaryBoxMetric[][];
  grid: boolean;
  summaryChildren: React.ReactNode[];
}

interface SummaryBoxMetricsProps {
  header: string;
  metrics: SummaryBoxMetric[];
  grid: boolean;
  children?: React.ReactNode;
}

export const SummaryBoxMetricsMulti: React.FC<SummaryBoxMetricsMultiProps> = ({
  header,
  metricsArr,
  grid,
  summaryChildren,
}) => {
  const metricDisplays = metricsArr.map((metrics) => {
    return metrics.map((metric, index) => {
      return (
        <HeaderWithSubheader
          header={metric.value}
          subheader={metric.valueSubText}
          dataTestId={metric.dataTestId}
          key={index}
          textAlign="left"
          fontSize="18px"
        />
      );
    });
  });

  return (
    <SummaryBoxMetricsContainer>
      {metricDisplays.map((metricDisplay, index) => {
        return (
          <div key={index}>
            {index === 0 ? (
              <Column $margin={"21px 15px 0 15px"} key={index}>
                <SectionHeaderWithSubHeaderDark
                  mainHeader={header}
                  headerFontSize={"20px"}
                />
              </Column>
            ) : (
              <hr style={{ width: "85%" }} />
            )}
            {grid && metricDisplay.length > 1 ? (
              <Grid
                $cols={2}
                $colwidth={"1fr"}
                $margin={"15px"}
                $padding={"0px 8px"}
                $gap={"0px"}
              >
                {metricDisplay}
              </Grid>
            ) : (
              <Column $margin={"15px"} $gap={"15px"}>
                {metricDisplay}
              </Column>
            )}
            {summaryChildren[index]}
          </div>
        );
      })}
    </SummaryBoxMetricsContainer>
  );
};

export const SummaryBoxMetrics: React.FC<SummaryBoxMetricsProps> = ({
  header,
  metrics,
  grid,
  children,
}) => {
  const metricDisplays = metrics.map((metric, index) => {
    return (
      <HeaderWithSubheader
        header={metric.value}
        subheader={metric.valueSubText}
        dataTestId={metric.dataTestId}
        key={index}
        textAlign="left"
        fontSize="18px"
      />
    );
  });
  return (
    <SummaryBoxMetricsContainer>
      <Column $margin={"21px 15px 0 15px"}>
        <SectionHeaderWithSubHeaderDark
          mainHeader={header}
          headerFontSize={"20px"}
        />
      </Column>
      {grid && metricDisplays.length > 1 ? (
        <Grid
          $cols={2}
          $colwidth={"1fr"}
          $margin={"15px"}
          $padding={"0px 8px"}
          $gap={"15px"}
        >
          {metricDisplays}
        </Grid>
      ) : (
        <Column $margin={"15px"} $gap={"15px"}>
          {metricDisplays}
        </Column>
      )}
      {children}
    </SummaryBoxMetricsContainer>
  );
};

const SummaryBoxMetricsContainer = styled(Column)`
  padding: 8px;
  width: 370px;
  background: #00022f;
  color: #ffffff;
  border-radius: 8px;
  flex-grow: 1;
  gap: 0;
`;
